import { makeObservable, observable, action } from "mobx";
// import authStore from "../../stores/AuthStore";

export default class BaseWebSocketHandler {
  socket = null;
  isConnected = false;
  subscribers = new Set();
  reconnectTimeout = null;

  constructor(url, messageParser = JSON.parse) {
    // const user = authStore.getUser();
    // const userId = user?.id || user?.userID;

    // if (!userId) {
    //   console.log(
    //     "❌ WebSocketHandler initialization failed: No user ID found."
    //   );
    //   return;
    // }

    this.url = url;
    this.messageParser = messageParser;

    makeObservable(this, {
      socket: observable.ref,
      isConnected: observable,
      connect: action,
      disconnect: action,
      send: action,
    });
  }

  connect() {
    if (
      this.socket ||
      this.isConnected ||
      this.socket?.readyState === WebSocket.OPEN
    )
      return;

    console.log("🌐 Connecting to WebSocket:", this.url);
    this.socket = new WebSocket(this.url);

    this.socket.onopen = () => {
      console.log("✅ WebSocket in BaseHandler connected!");
      this.isConnected = true;
    };

    this.socket.onclose = () => {
      console.warn("🔌 WebSocket disconnected");
      this.isConnected = false;
      this.socket = null;
      this.reconnectTimeout = setTimeout(() => this.connect(), 3000);
    };

    this.socket.onerror = (err) => {
      console.error("❌ WebSocket error:", err);
      this.socket?.close();
    };

    this.socket.onmessage = (message) => {
      // console.log("📩 Raw WebSocket message:", message.data);
      try {
        const parsedMessage = this.messageParser(message.data);
        this.subscribers.forEach((cb) => cb(parsedMessage));
      } catch (error) {
        console.error("⚠️ Failed to parse WebSocket message:", message.data);
      }
    };
  }

  send(data) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
    } else {
      console.warn("❗ WebSocket not open. Message not sent:", data);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
      clearTimeout(this.reconnectTimeout);
      this.socket = null;
      this.isConnected = false;
    }
  }

  subscribe(callback) {
    this.subscribers.add(callback);
  }

  unsubscribe(callback) {
    this.subscribers.delete(callback);
  }
}
